module.exports = __webpack_public_path__ + "static/media/creator_badge_ic.6d582871.svg";